import React from 'react';
import { Hero } from '../components/sections/Hero';
import { Identification } from '../components/sections/Identification';
import { Mechanism } from '../components/sections/Mechanism';
import { Benefits } from '../components/sections/Benefits';
import { Testimonials } from '../components/sections/Testimonials';
import { Bonuses } from '../components/sections/Bonuses';
import { OfferStack } from '../components/sections/OfferStack';
import { FAQ } from '../components/sections/FAQ';
import { FinalCTA } from '../components/sections/FinalCTA';
import { Guarantee } from '../components/sections/Guarantee';
import { PurchaseNotification } from '../components/PurchaseNotification';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-cream font-sans text-navy selection:bg-dusty-rose/30 selection:text-navy" data-id="element-349">
      <Hero data-id="element-350" />

      <Identification data-id="element-351" />
      <Mechanism data-id="element-352" />
      <Benefits data-id="element-353" />
      <Testimonials data-id="element-354" />
      <Bonuses data-id="element-355" />
      <OfferStack data-id="element-356" />
      <FAQ data-id="element-357" />
      <FinalCTA data-id="element-358" />
      <Guarantee data-id="element-359" />

      <PurchaseNotification data-id="element-360" />

      <footer className="bg-navy text-cream/70 py-12 text-center text-sm" data-id="element-361">
        <div className="max-w-6xl mx-auto px-4" data-id="element-362">
          <p className="mb-4 font-serif italic text-lg text-dusty-rose" data-id="element-363">
            © {new Date().getFullYear()} InfinitaMenteDigital. Todos los
            derechos reservados.
          </p>
          <p className="max-w-2xl mx-auto opacity-60 font-light" data-id="element-364">
            Este sitio no forma parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </main>;
}